module.exports = __webpack_public_path__ + "img/monitoring-truck-green.6108621a.svg";